<template>
  <v-navigation-drawer
    v-model="Sidebar_drawer"
    :dark="SidebarColor !== 'white'"
    :color="SidebarColor"
    mobile-breakpoint="960"
    clipped
    :right="$vuetify.rtl"
    mini-variant-width="70"
    :expand-on-hover="expandOnHover"
    app
    id="main-sidebar"
    v-bar
  >
    <!---USer Area -->
    <v-list-item two-line class="profile-bg">
      <v-list-item-avatar v-if="this.channel">
        <img
          v-if="!!this.channel.profileImage"
          v-bind:src="this.profileImageUrl"
        />
        <v-icon v-if="!this.channel.profileImage" color="white"
          >mdi-account-circle</v-icon
        >
      </v-list-item-avatar>

      <v-list-item-content class="white--text" v-if="this.channel">
        <v-list-item-title>{{ channel.channelId }}</v-list-item-title>
        <v-list-item-subtitle class="caption white--text"
          >{{ start }} ~ {{ showEndDate(end) }}</v-list-item-subtitle
        >
        <v-list-item-subtitle class="caption white--text" v-if="this.user">{{
          user.email
        }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <!---USer Area -->

    <v-list expand nav class="mt-1">
      <template v-for="(item, i) in items">
        <!---If Sidebar Caption -->
        <v-row v-if="item.header" :key="item.header" align="center">
          <v-col cols="12">
            <v-subheader v-if="item.header" class="d-block text-truncate">{{
              item.header
            }}</v-subheader>
          </v-col>
        </v-row>
        <!---If Sidebar Caption -->
        <BaseItemGroup
          v-else-if="item.children"
          :key="`group-${i}`"
          :item="item"
        ></BaseItemGroup>

        <BaseItem v-else :key="`item-${i}`" :item="item" />
      </template>
      <!---Sidebar Items -->
    </v-list>
    <v-divider></v-divider>
    <!--- Progress -->
    <v-list-item two-line>
      <v-list-item-content class>
        <v-list-item-title class="d-flex mb-3 align-center">
          <span class="body-2 text-truncate">Disk Usage</span>
          <div class="ml-auto">
            <h6 class="mb-0 info--text">
              <span>{{ showDiskSize(this.channelDisk.usage) }}</span>
              <span class="info--text">
                / {{ showDiskSize(this.channelDisk.alloc) }}
              </span>
              <span :class="{ 'red--text': diskOver }"
                >({{ this.channelDisk.usageRate }}%)</span
              >
            </h6>
          </div>
        </v-list-item-title>
        <v-progress-linear
          rounded
          :value="this.channelDisk.usageRate"
        ></v-progress-linear>
      </v-list-item-content>
    </v-list-item>
    <!--- Progress -->
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import VerticalSidebarItems from "./VerticalSidebarItems";
export default {
  name: "Vertical-Sidebar",
  props: {
    expandOnHover: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    items: VerticalSidebarItems,
    start: "",
    end: ""
  }),
  computed: {
    ...mapState([
      "SidebarColor",
      "SidebarBg",
      "channel",
      "user",
      "channelDisk"
    ]),
    Sidebar_drawer: {
      get() {
        return this.$store.state.Sidebar_drawer;
      },
      set(val) {
        this.$store.commit("SET_SIDEBAR_DRAWER", val);
      }
    },
    profileImageUrl: function() {
      return (
        process.env.VUE_APP_BASE_URL +
        `/pub/channel/${this.channel.channelId}/profile/` +
        this.channel.profileImage
      );
    },
    diskOver: function() {
      let rtn = false;
      if (this.channelDisk && this.channelDisk.usage > this.channelDisk.alloc) {
        rtn = true;
      }
      return rtn;
    }
  },
  watch: {
    "$vuetify.breakpoint.smAndDown"(val) {
      this.$emit("update:expandOnHover", !val);
    }
  },

  methods: {
    showEndDate(dateVal) {
      if (dateVal) {
        return this.$moment(dateVal)
          .subtract(1, "days")
          .format("YYYY-MM-DD");
      } else {
        return "-";
      }
    },
    showDiskSize(diskVal) {
      if (diskVal && !isNaN(diskVal)) {
        if (diskVal >= 1024) {
          return `${(diskVal / 1024).toFixed(1)}TB`;
        }
        return `${diskVal}GB`;
      } else {
        return "-";
      }
    }
  },
  async mounted() {
    try {
      const channelId = this.channel.channelId;
      const basicLicense = this.channel.licenses.find(
        license => license.mode == "basic"
      );
      const diskLicenses = this.channel.licenses.filter(
        license => license.mode == "disk" || license.mode == "basic"
      );
      // 채널 유효날짜 가져오기
      console.log({ basicLicense });
      this.start = basicLicense ? basicLicense.start : "0000-00-00";
      this.end = basicLicense ? basicLicense.end : "0000-00-00";

      // 채널 Disk 사용량 가져오기
      diskLicenses.forEach(lic => {
        this.diskAlloc = this.diskAlloc + lic.disk;
      });

      await this.$store.dispatch("getChannelDisk", channelId);
      setInterval(() => {
        this.$store.dispatch("getChannelDisk", channelId);
      }, 60000);
    } catch (e) {
      console.log(e);
    }
  }
};
</script>
<style lang="scss">
#main-sidebar {
  box-shadow: 1px 0 20px rgba(0, 0, 0, 0.08);
  -webkit-box-shadow: 1px 0 20px rgba(0, 0, 0, 0.08);
  .v-navigation-drawer__border {
    display: none;
  }
  .v-list {
    padding: 8px 15px;
  }
  .v-list-item {
    &__icon--text,
    &__icon:first-child {
      justify-content: center;
      text-align: center;
      width: 20px;
    }
  }
  .profile-bg {
    background: url("../../../assets/images/channel-info.jpg") no-repeat;
    .v-avatar {
      padding: 45px 0;
    }
  }
}
/* 이부분 색상 변경하면 사이드 메뉴 색상 변경하는 것 
.v-application a {
  color: #44633f;
}
.v-list .v-list-item--active {
  color: #44633f;
}
*/
</style>
